import { Paper, Table, TableBody, TableHead, TableRow } from "@mui/material";

import { useI18difference } from "../../../../../../../../../hooks";

import { IconSprite } from "../../../../../../../../../components/ui/IconSprite/IconSprite";

import {
  BodyCell,
  ContainerTable,
  HeadCell,
  Wrapper,
  WrapperRoot,
} from "./DifferencesTable.styled";

export const DifferencesTable = () => {
  const isOdd = num => num % 2 !== 0;

  const getIcon = value => {
    return value ? (
      <IconSprite tag="confirm" width="28" height="28" />
    ) : (
      <IconSprite tag="minus" width="28" height="28" />
    );
  };

  // const tableHead = t("difference.tableHead", { returnObjects: true });
  // const rows = t("difference.rows", { returnObjects: true });
  const { tableHead, rows } = useI18difference();

  return (
    <WrapperRoot>
      <Wrapper>
        <ContainerTable component={Paper}>
          <Table aria-label="differences table">
            <TableHead>
              <TableRow>
                {tableHead.map((title, idx) => (
                  <HeadCell idx={idx} key={idx}>
                    {title}
                  </HeadCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, idx) => (
                <TableRow key={row.name}>
                  <BodyCell isOdd={isOdd(idx)} full>
                    {row.name}
                  </BodyCell>

                  <BodyCell isOdd={isOdd(idx)} center>
                    {getIcon(row.vpn)}
                  </BodyCell>

                  <BodyCell isOdd={isOdd(idx)} center>
                    {getIcon(row.proxy)}
                  </BodyCell>

                  <BodyCell isOdd={isOdd(idx)} center radius>
                    {getIcon(row.anonymizer)}
                  </BodyCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </ContainerTable>
      </Wrapper>
    </WrapperRoot>
  );
};

export default DifferencesTable;
